import { createFileRoute, redirect } from "@tanstack/react-router";

// The old page lives on as a permanent redirect so existing links and search results keep working.
export const Route = createFileRoute("/experience")({
  beforeLoad: () => {
    throw redirect({ to: "/chef-buddy", statusCode: 301 });
  },
});
